import { useQuery } from "@tanstack/react-query";

export type AnalyticsRange = "24h" | "7d" | "30d";

export interface AnalyticsTopQuery {
  query: string;
  hits: number;
  sessions: number;
  avg_results: number;
}

export interface AnalyticsCountry {
  country: string | null;
  hits: number;
}

export interface AnalyticsTopTag {
  tag: string;
  hits: number;
}

export interface AnalyticsSeriesPoint {
  ts: string;
  hits: number;
}

export interface AnalyticsResponse {
  range: AnalyticsRange;
  total_queries: number;
  distinct_sessions: number;
  top_queries: AnalyticsTopQuery[];
  top_tags: AnalyticsTopTag[];
  countries: AnalyticsCountry[];
  series: AnalyticsSeriesPoint[];
}

async function fetchAnalytics(range: AnalyticsRange): Promise<AnalyticsResponse> {
  const res = await fetch(`/api/v1/admin/analytics?range=${range}`, {
    credentials: "same-origin",
  });
  if (!res.ok) {
    throw new Error(`analytics fetch failed: ${res.status}`);
  }
  return res.json();
}

export function useAnalytics(range: AnalyticsRange) {
  return useQuery<AnalyticsResponse>({
    queryKey: ["admin", "analytics", range],
    queryFn: () => fetchAnalytics(range),
    staleTime: 30_000,
  });
}
